import classnames from "classnames";
import React, { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { FormControl } from "../../Form/Form";
import FormHelper from "../../Form/FormHelper";
import RadioButton from "../../Form/RadioButton";

import useIntakeFormStore from "../../../store/IntakeForm.store";

import "./creditQualityGroupField.scss";

export const creditQualities = ["AAA", "AA", "A", "BBB"];

export const checkInputDisabled = (
  inputQual,
  minCredQual,
  isCustCreditQualAllowed
) => {
  if (!isCustCreditQualAllowed) return true;
  if (!minCredQual) return false;

  if (creditQualities.indexOf(minCredQual) < 1) return true;
  return (
    creditQualities.indexOf(minCredQual) < creditQualities.indexOf(inputQual)
  );
};

export const getCreditQualityInputValue = (
  value,
  inputQual,
  minCredQual,
  isCustCreditQualAllowed
) => {
  if (value === "" || value === undefined) {
    if (creditQualities.indexOf(minCredQual) < 1) return false;
    return (
      creditQualities.indexOf(minCredQual) >= creditQualities.indexOf(inputQual)
    );
  }
  if (typeof value === "string" && value.startsWith("INCLUDE")) {
    return value[8] === "Y";
  }
  return value;
};

const CreditQualityGroupField = () => {
  const formState = useIntakeFormStore((state) => state.data.formState);
  const formData = useIntakeFormStore((state) => state.data.formData);
  const {
    control,
    setValue,
    getValues,
    formState: { errors },
    trigger,
    unregister,
  } = useFormContext();
  const statePreference = useWatch({
    control,
    name: "statePreference",
  });
  const isLocked = formState.isFormLocked;
  const { strategyDetail } = formState;
  const minCredQual = strategyDetail?.minCredQual;
  const [isMunicipal, setIsMunicipal] = useState(false);

  const inputFields = [
    {
      id: "credit_quality_SI",
      name: "credit_quality_SI",
      label: "AA and higher",
      options: {
        readOnly: formState.category === "Corporate Bonds",
        options: [
          {
            subtext: "",
            label: "AA and higher",
            value: "AA,AAA",
            layout: "horizontal",
            defaultChecked: true,
          },
        ],
      },
    },
    {
      id: "credit_quality_SI",
      name: "credit_quality_SI",
      label: "A and higher",
      options: {
        disabled: true,
        readOnly: isLocked,
        options: [
          {
            subtext: "",
            label: "A and higher",
            value: "A,AA,AAA",
            layout: "horizontal",
          },
        ],
      },
    },
    {
      id: "credit_quality_SI",
      name: "credit_quality_SI",
      label: "BBB and higher",
      options: {
        disabled: false,
        readOnly: formState.category === "Municipal Bonds",
        options: [
          {
            subtext: "",
            label: "BBB and higher",
            value: "BBB,A,AA,AAA",
            layout: "horizontal",
          },
        ],
      },
    },
    {
      id: "credit_quality_SI",
      name: "credit_quality_SI",
      label: "A and BBB only",
      options: {
        disabled: false,
        readOnly: formState.category === "Municipal Bonds",
        options: [
          {
            subtext: "",
            label: "A and BBB only",
            value: "BBB,A",
            layout: "horizontal",
          },
        ],
      },
    },
  ];

  const errorKeys = Object.keys(errors);
  const hasError = errorKeys.some((err) => err.match(/^cqSi/));

  useEffect(() => {
    if (formData?.credit_quality_SI) {
      setValue("credit_quality_SI", formData.credit_quality_SI);
    }
    return () => {};
  }, [formData]);

  return (
    <FormControl className="form-control--table">
      <div
        className={classnames("credit-quality", {
          "has-error": hasError,
        })}
      >
        <table className="credit-quality__table">
          <thead>
            <tr>
              <th scope="col" className="title">
                Credit Quality (Choose One)
              </th>
            </tr>
          </thead>
          <tbody>
            {inputFields.map((item, index) => {
              return (
                <tr>
                  <RadioButton {...item} />
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {hasError && (
        <FormHelper
          error={{
            message: "The Min % cannot exceed that of the Max % and vice versa",
          }}
        />
      )}
    </FormControl>
  );
};

export default CreditQualityGroupField;
